<template>
	<div class="control-group" :class="{filled: text && (''+text).length > 0, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" :class="{'has-prepend': prependIcon}">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon, 'has-prepend': prependIcon}">
				<span v-if="prependIcon" @click.prevent="$emit('click:prepend')" class="prepend-icon">
					<icon :icon="prependIcon"></icon>
				</span>
				<div class="input-holder">
			        <input 
			        	ref="input"
				        :type="(type)?type:'text'" 
				        :disabled="disabled" 
				        :readonly="readonly"
				        v-model="text" 
				        :maxlength="(maxLength)?maxLength:null"
				        :minlength="(minLength)?minLength:null"
				        :placeholder="(placeholder)?(placeholder + ((required)?'*':'')):''" 
				        :autocomplete="(autocomplete)?autocomplete:false" 
				        @click="$emit('focus')"
				        @focus="focused = true; $emit('focus')" 
				        @blur="focused = false; $emit('blur')" 
				        @change="$emit('change', $event)"
				        @keyup="$emit('keyup', $event)"
				        :inputmode="inputmode"
			        />
			    </div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append', $event)" class="append-icon">
		    		<icon :icon="appendIcon"></icon>
		    	</span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'type', 'required', 'placeholder', 'disabled', 'appendIcon', 'prependIcon', 'autocomplete', 'readonly', 'maxLength', 'minLength', 'inputmode'],
		data() {
			return {
				text: this.value,
				focused: false
			}
		},
		watch: {
			text() {
				if(!this.text) {
					this.text = '';
				}
				this.$emit('input', this.text);
			},
			value() {
				this.text = this.value;
			}
		},
		methods: {
			focus() {
				this.$refs.input.focus();
			}
		}
	}
</script>